import type { ProtheusClient } from './types';

export type ProtheusRecipientType = 'CLIENT' | 'SUPPLIER';

type ProtheusRecipientEmails = Pick<ProtheusClient, 'email' | 'distributionEmail'>;

export function resolveProtheusRecipientEmail(
  recipient: ProtheusRecipientEmails,
  recipientType: ProtheusRecipientType
): string {
  return recipientType === 'SUPPLIER' ? recipient.distributionEmail : recipient.email;
}

export function hasProtheusRecipientEmail(
  recipient: ProtheusRecipientEmails,
  recipientType: ProtheusRecipientType
): boolean {
  return resolveProtheusRecipientEmail(recipient, recipientType).trim() !== '';
}
